<template>
  <div class="load-add">
    <keep-alive>
      <edit/>
    </keep-alive>
  </div>
</template>
<script>
  import edit from './edit';

  export default {
    components: {
      edit,
    },
    name: 'adminAddBillLadingLading',
    data() {
      return {
        start: true,
      };
    },
    watch: {
      // '$route.name': function() {
      //   this.start = false;
      //   this.$nextTick(() => {
      //     this.start = true;
      //   });
      // },
    },
  };
</script>
<style>
  .load-add {
    width: 100%;
  }
</style>
